import styled from 'styled-components';

const StyledGuidanceItem = styled.section`
	display: flex;
	border-top: var(--px-1) solid var(--neutrals-300);
	margin-top: var(--px-10);
	padding-top: var(--px-15);
	&:first-child {
		border-top: unset;
		margin-top: 0;
		padding-top: 0;
	}
	span {
		p {
			line-height: initial;
			font-size: var(--px-14);
		}
		ol,
		ul {
			margin-left: var(--px-30);
			padding-left: 0;
			li {
				margin-left: var(--px-28);
				margin-bottom: var(--px-10);
			}
		}
		ul {
			li {
				list-style-type: initial;
				margin-left: var(--px-28);
			}
		}
	}
`;

export default StyledGuidanceItem;
